import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { getEntityCategories, getEntityFamilies, getEntityProducts, getEntitySegments } from '../../services/entities'

const SERVICES_DICTIONARY = {
  categories: getEntityCategories,
  families: getEntityFamilies,
  products: getEntityProducts,
  segments: getEntitySegments
}

const TYPES_DICTIONARY = {
  categories: 'categories',
  families: 'families',
  products: 'products',
  segments: 'segments'
}

const KEYS_DICTIONARY = {
  categories: { amount: 'amountCategory', label: 'category', name: 'idCategory', type: 'categories' },
  families: { amount: 'amountFamily', label: 'family', name: 'idFamily', type: 'families' },
  products: { amount: 'amountProduct', label: 'product', name: 'idProduct', type: 'products' },
  segments: { amount: 'amountSegment', label: 'segment', name: 'idSegment', type: 'segments' }
}

export const GET_TRADED_ITEMS = 'GET_TRADED_ITEMS'
export const GET_TRADED_ITEMS_ERROR = 'GET_TRADED_ITEMS_ERROR'
export const GET_TRADED_ITEMS_SUCCESS = 'GET_TRADED_ITEMS_SUCCESS'
export const onGetTradedItems = makeActionCreator(GET_TRADED_ITEMS)
export const onGetTradedItemsError = makeActionCreator(GET_TRADED_ITEMS_ERROR, 'payload')
export const onGetTradedItemsSuccess = makeActionCreator(GET_TRADED_ITEMS_SUCCESS, 'payload')
export const onGetTradedItemsThunk = payload => async dispatch => {
  dispatch(onGetTradedItems())

  try {
    const { data = {} } = await SERVICES_DICTIONARY[payload.type]({
      categoryId: payload.categoryId,
      entityId: payload.entityId,
      familyId: payload.familyId,
      productId: payload.productId,
      segmentId: payload.segmentId,
      year: payload.year
    })
    const { data: collection = [] } = data.payload.find(item => item.year === payload.year)
    const chartStructure = collection
      .map(item => {
        return {
          amount: item[KEYS_DICTIONARY[payload.type].amount],
          categoryId: item.idCategory !== 0 ? item.idCategory : undefined,
          familyId: item.idFamily !== 0 ? item.idFamily : undefined,
          label: item[KEYS_DICTIONARY[payload.type].label],
          name: item[KEYS_DICTIONARY[payload.type].name],
          productId: item.idProduct !== 0 ? item.idProduct : undefined,
          segmentId: item.idSegment !== 0 ? item.idSegment : undefined,
          type: TYPES_DICTIONARY[payload.type]
        }
      })
      .sort((item1, item2) => item2.amount - item1.amount)
      .map((item, index) => ({
        ...item,
        index,
        drilldown: item.type !== 'products',
        parent: index + 1
      }))
    const csvStructure =
      [['Nombre rubro', 'Monto total (CLP)'], ...chartStructure?.map(item => [item.label, item.amount])] || []
    return batch(() => {
      dispatch(onGetTradedItemsSuccess({ ...payload, chartStructure, csvStructure }))
      payload.callback && payload.callback()
    })
  } catch (error) {
    return dispatch(onGetTradedItemsError({ error }))
  }
}
